import { cache_read, cache_write } from "src/components/js/CacheFunctions";
import { isNextDay, parse_yyyymmddhhmm } from "src/components/js/statics1";

export async function personPvm_updatePersonVehicle(
  ownerAsiakasId,
  personId,
  vehicleId,
  yyyymmdd,
  token
) {
  const fullUrl =
    import.meta.env.VITE_SERVER_URL + "/api/personPvm/updatePersonVehicle/" + ownerAsiakasId;
  const response = await fetch(fullUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": `${token}`,
    },
    body: JSON.stringify({
      personId,
      vehicleId,
      yyyymmdd,
    }),
  });
  const data = await response.json();
  return data;
}

export async function personPvm_update(
  ownerAsiakasId,
  personPvmId,
  personId,
  pvm,
  personPvmStatusId,
  foreignKey,
  personPvmText,
  token
) {
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/personPvm/update/" + ownerAsiakasId;
  const response = await fetch(fullUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": `${token}`,
    },
    body: JSON.stringify({
      personPvmId,
      personId,
      pvm,
      personPvmStatusId,
      foreignKey,
      personPvmText,
    }),
  });
  const data = await response.json();
  return data;
}

// if endDate is null, it select all personPvm records for the person starting from startDate
// if personId is null, it select all personPvm records for the asiakas starting from startDate
export async function personPvm_list(ownerAsiakasId, startDate, endDate, personId, token) {
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/personPvm/list/" + ownerAsiakasId;
  const response = await fetch(fullUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": `${token}`,
    },
    body: JSON.stringify({
      startDate,
      endDate,
      personId,
    }),
  });
  const data = await response.json();
  return data;
}

export async function personPvm_delete(personPvmId, token) {
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/personPvm/delete/" + personPvmId;
  const response = await fetch(fullUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": `${token}`,
    },
    body: JSON.stringify({
      personPvmId,
    }),
  });
  const data = await response.json();
  return data;
}

export async function personPvm_getStatusList(ownerAsiakasId, token) {
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/personPvm/statusList/" + ownerAsiakasId;
  const cache = await cache_read("personPvm_statusList", fullUrl);
  if (cache) return cache;
  const response = await fetch(fullUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": `${token}`,
    },
  });
  const data = await response.json();
  cache_write("personPvm_statusList", fullUrl, data, 3600);
  return data;
}

export async function personPvm_save(
  personPvmId,
  ownerAsiakasId,
  personId,
  pvm,
  personPvmStatusId,
  personPvmText,
  vehicleId,
  token
) {
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/personPvm/save/" + ownerAsiakasId;
  const response = await fetch(fullUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": `${token}`,
    },
    body: JSON.stringify({
      personPvmId,
      personId,
      pvm,
      personPvmStatusId,
      personPvmText,
      vehicleId,
    }),
  });
  return await response.json();
}

export function personPvmStatus_save(status, token) {
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/personPvm/status/save";
  return fetch(fullUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": `${token}`,
    },
    body: JSON.stringify(status),
  });
}

export function personPvm_getPoisList(
  tableData,
  personId,
  statusList,
  startPvm = null,
  endPvm = null
) {
  // filter from table only rows that are for the person and are between startPvm and endPvm
  // and personPvmStatusId is in statusList.pois = true and statusList.vakioVapaa = false
  const _poisData = tableData.filter(
    (row) =>
      row.personId === personId &&
      (startPvm === null || row.pvm >= startPvm) &&
      (endPvm === null || row.pvm <= endPvm) &&
      statusList.find((status) => status.personPvmStatusId === row.personPvmStatusId)?.pois
    //  && !statusList.find((status) => status.personPvmStatusId === row.personPvmStatusId)?.vakioVapaa
  );
  if (_poisData.length === 0) return [];

  const _poisList = [];
  // let row = {
  //   firstPvm: firstPvm,
  //   lastPvm: firstPvm,
  //   personPvmStatus: _poisData[0].personPvmStatus,
  //   personPvmStatusId: _poisData[0].personPvmStatusId,
  //   personPvmStatusIds: [],
  // };
  // create a list list of pois periods
  let firstPvm = _poisData[0].pvm;
  let firstDate = parse_yyyymmddhhmm(firstPvm);
  // firstDate = normalizeToUTC(firstDate);
  let previousDate = new Date(firstDate); // Create a new Date object to avoid mutation
  // previousDate = normalizeToUTC(previousDate);

  let previous_personPvmStatusId = _poisData[0].personPvmStatusId;
  let previous_pois = _poisData[0].pois;
  let onlyVakioVapaa = true;
  let personPvmStatusIds = [];
  for (let i = 0; i < _poisData.length; i++) {
    const _poisDataRow = _poisData[i];
    let currentDate = parse_yyyymmddhhmm(_poisDataRow.pvm);
    // currentDate = normalizeToUTC(currentDate);

    if (
      _poisDataRow.personPvmStatusId === previous_personPvmStatusId &&
      _poisDataRow.pvm === firstPvm
    )
      continue;
    const _isNextDay = isNextDay(previousDate, currentDate);
    // const sameStatusId = _poisDataRow.personPvmStatusId == previous_personPvmStatusId;
    const sameStatusId = _poisDataRow.pois === previous_pois;
    personPvmStatusIds.push({
      personPvmId: _poisDataRow.personPvmId,
      personPvmStatusId: _poisDataRow.personPvmStatusId,
      vakioVapaa: _poisDataRow.vakioVapaa,
      personPvmStatus: _poisDataRow.personPvmStatus,
      style: _poisDataRow.style,
    });
    if (!_poisDataRow.vakioVapaa) onlyVakioVapaa = false;
    if (!sameStatusId && _isNextDay) {
      // console.log("different personPvmStatusId and next day");
    }
    // if ((sameStatusId || _poisDataRow.pois) && isNextDay && i < _poisData.length - 1) {
    if (sameStatusId && _isNextDay) {
      // console.log("same personPvmStatusId and next day");
      // same personPvmStatusId and next day
    } else {
      // personPvmStatusId has changed
      // console.log("personPvmStatusId has changed");
      const _status = statusList.find(
        (status) => status.personPvmStatusId === _poisData[i - 1].personPvmStatusId
      );
      if (!onlyVakioVapaa)
        _poisList.push({
          personId: personId,
          firstPvm: firstPvm,
          lastPvm: _poisData[i - 1].pvm,
          firstDate: firstDate,
          lastDate: previousDate,
          dayCount: (previousDate - firstDate) / 86400000 + 1,
          personPvmStatus: _poisData[i - 1].personPvmStatus,
          personPvmStatusId: _poisData[i - 1].personPvmStatusId,
          personFirstName: _poisDataRow.personFirstName,
          personLastName: _poisDataRow.personLastName,
          personPvmStatusName: _status.personPvmStatusName,
          style: _status.style,
          prefix: _status.prefix,
          personPvmStatusIds: personPvmStatusIds,
        });
      onlyVakioVapaa = true;
      personPvmStatusIds = [];
      firstPvm = _poisDataRow.pvm;
      firstDate = currentDate;
      previous_personPvmStatusId = _poisDataRow.personPvmStatusId;
      previous_pois = _poisDataRow.pois;
    }
    previousDate = currentDate;
  }
  _poisList.push({
    personId: personId,
    firstPvm: firstPvm,
    lastPvm: _poisData[_poisData.length - 1].pvm,
    firstDate: firstDate,
    lastDate: previousDate,
    dayCount: (previousDate - firstDate) / 86400000 + 1,
    personPvmStatus: _poisData[_poisData.length - 1].personPvmStatus,
    personPvmStatusId: _poisData[_poisData.length - 1].personPvmStatusId,
    personFirstName: _poisData[_poisData.length - 1].personFirstName,
    personLastName: _poisData[_poisData.length - 1].personLastName,
    personPvmStatusName: statusList.find(
      (status) => status.personPvmStatusId === _poisData[_poisData.length - 1].personPvmStatusId
    ).personPvmStatusName,
    style: statusList.find(
      (status) => status.personPvmStatusId === _poisData[_poisData.length - 1].personPvmStatusId
    ).style,
    prefix: statusList.find(
      (status) => status.personPvmStatusId === _poisData[_poisData.length - 1].personPvmStatusId
    ).prefix,
    personPvmStatusIds: personPvmStatusIds,
  });
  return _poisList;
}

export async function personPvm_fix(ownerAsiakasId, token) {
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/personPvm/lomaFix/" + ownerAsiakasId;
  const response = await fetch(fullUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": `${token}`,
    },
  });
  const data = await response.json();
  console.log(data);
  return data;
}
